import prop from 'ramda/src/prop'
import propOr from 'ramda/src/propOr'
import anyPass from 'ramda/src/anyPass'
import compose from 'ramda/src/compose'
import not from 'ramda/src/not'
import equals from 'ramda/src/equals'
import { PARTITION_KEY, SORT_KEY } from 'root/src/shared/constants/apiDynamoIndexes'
import { projectAcceptedKey, projectApprovedKey, projectDeliveryPendingKey, userIdKey } from 'root/src/shared/constants/keys'

export const authenticationProp = prop('authentication')
export const payloadSchemaProp = prop('payloadSchema')
export const toInternalValueProp = prop('toInternalValue')
export const actionProp = prop('action')
export const toRepresentationProp = prop('toRepresentation')
export const responseSchemaProp = prop('responseSchema')

export const authenticationPropOr = propOr('authentication')
export const payloadSchemaPropOr = propOr('payloadSchema')
export const toInternalValuePropOr = propOr('toInternalValue')
export const actionPropOr = propOr('action')
export const toRepresentationPropOr = propOr('toRepresentation')
export const responseSchemaPropOr = propOr('responseSchema')

export const pkProp = prop(PARTITION_KEY)
export const skProp = prop(SORT_KEY)
export const skSeparator = '|'
export const userIdProp = prop(userIdKey)

export const dynamoItemsProp = prop('Items')

export const isProjectComplete = compose(not, anyPass([
	equals(projectAcceptedKey),
	equals(projectApprovedKey),
	equals(projectDeliveryPendingKey),
]))
